(function ($) {
  Drupal.behaviors.desire_shades_carousel_slide = {
    showChildren: function (context, delay) {
      var $shades = $('.desire-shades-carousel__shade', context);

      delay = delay || 1500;

      for (var i = 0; i < $shades.length; i++) {
        (function ($shade) {
          setTimeout(function () {
            $shade.addClass('visible');
          }, Math.floor(Math.random() * delay));
        })($shades.eq(i));
      }
    },
    hideChildren: function (context, delay) {
      var $shades = $('.desire-shades-carousel__shade', context);

      delay = delay || 500;

      for (var i = 0; i < $shades.length; i++) {
        (function ($shade) {
          setTimeout(function () {
            $shade.removeClass('visible');
          }, Math.floor(Math.random() * delay));
        })($shades.eq(i));
      }
    }
  };
})(jQuery);
